import axios from "axios";
import React, { createContext, useCallback, useEffect, useState } from "react";
// import { Navigate } from "react-router-dom";
import { baseUrl } from "../utils/baseUrl.js";
import { toast } from "react-toastify";

export const WishListContext = createContext();

export default function WishListContextProvider({ children }) {

    const tkn = localStorage.getItem("authorization")
    const token = "ecomm__" + tkn
    const [wishItems, setWishItems] = useState([])
    const notify = (msg, type) => toast[type](msg);

    const getWishItems = useCallback(() => {
        axios.get(
            `${baseUrl}/wishList`,
            {
                headers: { authorization: token },
            }
        ).then((response) => {
            if (response.status === 200) {
                setWishItems(response.data?.userWishList?.wishList)
            }
        }).catch((error) => {
            notify("Can't get user wishList", "error")
        })
    }, [token])

    useEffect(() => {
        if (tkn) {
            getWishItems()
        }
    }, [tkn, getWishItems])



    async function addProductToWishList(productId) {
        const { data } = await axios.patch(
            `${baseUrl}/wishList/add`,
            {
                productId,
            },
            {
                headers: { authorization: token },
            }
        );
        getWishItems()
        if (data.message === "done") {
            notify("Added", "success")
        } else {
            notify("Failed", "error")
        }
    }

    async function removeProductFromWishList(productId) {
        const { data } = await axios.patch(
            `${baseUrl}/wishList/remove`,
            {
                productId,
            },
            {
                headers: { authorization: token },
            }
        );
        getWishItems()
        if (data.message === "done") {
            notify("Removed", "success")
        } else {
            notify("Failed", "error")
        }
    }

    const ids = []

    wishItems?.map(item => {
        return ids.push(item._id)
    })


    function contains(ids, projId) {
        for (var i = 0; i < ids.length; i++) {
            if (ids[i] === projId) {
                return true;
            }
        }
        return false;
    }


    return (
        <WishListContext.Provider value={{ getWishItems, wishItems, contains, ids, addProductToWishList, removeProductFromWishList }} >
            {children}
        </WishListContext.Provider>
    )

}
